<template>
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="12" md="5" class="border-right">
          <v-toolbar flat dense color="transparent">
            <v-toolbar-title class="subtitle-1 font-weight-bold">File History & Notes</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small color="primary" @click="showNoteDialog = true">
              <v-icon left small>mdi-comment-plus</v-icon> Add Note
            </v-btn>
          </v-toolbar>
  
          <v-timeline dense clipped>
            <v-timeline-item
              v-for="(event, index) in caseData.chronology"
              :key="index"
              :color="event.type === 'milestone' ? 'primary' : 'grey'"
              small
            >
              <v-card outlined>
                <v-card-text class="pa-2">
                  <div class="caption font-weight-bold">{{ event.date }} - {{ event.author }}</div>
                  <div class="body-2">{{ event.description }}</div>
                  <div style="display: flex;justify-content: end;">
                  <v-icon color="red" dark @click="openDeleteNoteDialog(event)">mdi-delete</v-icon>
                </div>
                </v-card-text>

                
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-col>
  
        <v-col cols="12" md="7">
          <v-toolbar flat dense color="transparent">
            <v-toolbar-title class="subtitle-1 font-weight-bold">Active Tasks & Steps</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small color="success" @click="showTaskDialog = true">
              <v-icon left small>mdi-plus</v-icon> New Task
            </v-btn>
          </v-toolbar>
  
          <v-row class="px-2">
            <v-col v-for="column in taskColumns" :key="column.id" cols="12" md="6">
              <v-card color="grey lighten-4" flat min-height="500">
                <v-subheader class="font-weight-black text-uppercase">
                  {{ column.title }} ({{ getTasksByStatus(column.id).length }})
                </v-subheader>
                
                <div 
                  class="task-list-container"
                  @dragover.prevent
                  @drop="onDrop($event, column.id)"
                >
                  <v-card
                    v-for="task in getTasksByStatus(column.id)"
                    :key="task.id"
                    draggable="true"
                    @dragstart="onDragStart($event, task)"
                    class="ma-2 pa-3"
                    elevation="1"
                  >
                    <div class="d-flex justify-space-between align-start">
                      <span class="caption font-weight-bold primary--text">{{ task.end }}</span>
                      <v-chip x-small outlined>{{ task.assignedTo }}</v-chip>
                    </div>
                    <div class="body-2 mt-1">{{ task.title }}</div>
                  </v-card>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      
      <CaseTaskDialog v-model="showTaskDialog" @save="handleTaskSave"></CaseTaskDialog>

      <v-dialog v-model="showNoteDialog" max-width="400">
        <v-card>
          <v-card-title>New Chronology Note</v-card-title>
          <v-card-text>
            <v-textarea v-model="newNode.description" outlined label="What happened?" hide-details></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showNoteDialog = false">Cancel</v-btn>
            <v-btn color="primary" @click="saveNote">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteNoteDialog" max-width="400">
        <v-card v-if="noteToBeDeleted">
          <v-card-title style="color: red;">Confirm Delete</v-card-title>
          <v-card-text>
            you are about to delete the note below<br/>
            {{ noteToBeDeleted.description }}
            <br/>
            <strong>This action cannot be reveresed. Click Delete Now to delete it now </strong>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeDeleteNoteDialog()">Cancel</v-btn>
            <v-btn color="error" @click="deleteItem()">Delete Now</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </template>
  
  <script>
  import axios from "@/plugins/axios"
  import helpersJs from "@/plugins/helpers"
  import CaseTaskDialog from './CaseTaskDialog.vue';

  export default {
    props: {
      caseData: {
        type: Object,
        required: true
      }
    },
    components:{
        CaseTaskDialog
    },
    computed:{
      getAccessToken(){
        return this.$store.getters.getAccessToken
      },
      getAppMode(){
        return this.$store.getters.getAppMode
      },

    },
    data() {
      return {
        showNoteDialog: false,
        showTaskDialog: false,
        deleteNoteDialog:false,
        noteToBeDeleted:null,
        newNode: { description: '' },
        taskColumns: [
          { id: 'todo', title: 'To-Do / Upcoming' },
          { id: 'completed', title: 'Completed' }
        ],
        // For drag and drop tracking
        draggedTask: null
      }
    },
    methods: {
      getTasksByStatus(status) {
        if (!this.caseData.tasks) return [];
        return this.caseData.tasks.filter(t => t.status === status);
      },
      onDragStart(event, task) {
        this.draggedTask = task;
        event.dataTransfer.effectAllowed = 'move';
      },
      onDrop(event, newStatus) {
        if (this.draggedTask) {
          this.draggedTask.status = newStatus;
          this.$store.commit('setLoader',true)
          axios.postDataWithToken("/auth/update-case-task-status",{
            taskID: this.draggedTask.id,
            status: newStatus
          },this.getAccessToken)
          .then(res => {
            this.$store.commit('setLoader',false)
            if(res && res.status === "success"){
              this.$toast.success("Task marked completed!",{duration:5000})
            }else{
              this.$toast.error(res.message)
            }
          })
          
          //this.draggedTask = null;
          // In real app, emit update to parent/API here
        }
      },
      saveNote() {
        const note = {
          id:null,
          date: new Date().toISOString().substr(0, 10),
          author: 'Admin User',
          description: this.newNode.description,
          type: 'note'
        };
        if (!this.caseData.chronology) {
          this.$set(this.caseData, 'chronology', []);
        }
        
        this.$store.commit('setLoader',true)
        const ref = this.caseData.internalRef ? this.caseData.internalRef : this.caseData.invoice_number
        axios.postDataWithToken("/auth/save-or-update-case-notes",{
          internalRef: ref,
          note: note
        },this.getAccessToken)
        .then(res => {
          this.$store.commit('setLoader',false)
          if(res && res.status === "success"){
            this.caseData.chronology = res.notes
            this.$toast.success("Note saved successfully!",{duration:5000})
          }else{
            this.$toast.error(res.message,{duration:5000})
          }
        })
        // this.caseData.chronology.unshift(note);
        // console.log(this.caseData.chronology)
        this.newNode.description = '';
        this.showNoteDialog = false;
      },
      openDeleteNoteDialog(note){
        this.noteToBeDeleted = note
        this.deleteNoteDialog = true
      },
      closeDeleteNoteDialog(note){
        this.deleteNoteDialog = false
        this.noteToBeDeleted = null
      },
      async deleteItem(){
        this.$store.commit('setLoader',true)
        let table = null 
        if(this.noteToBeDeleted && this.noteToBeDeleted.type == 'note'){
          table = 'notes'
        }else{
          table = 'tasks'
        }
        await helpersJs.deleteSingleRow('notes', this.noteToBeDeleted.id)
        this.$store.commit('setLoader',false)
        this.$toast.success('Item deleted successfully!',{duration:5000})
        const index = this.caseData.chronology.findIndex(entry => entry.id === this.noteToBeDeleted.id);

        if (index !== -1) {
          this.caseData.chronology.splice(index, 1);
        }
        this.closeDeleteNoteDialog()
      },
      handleTaskSave(newTask) {
      if (!this.caseData.tasks) {
        this.$set(this.caseData, 'tasks', []);
      }
      
      
      this.$store.commit('setLoader',true)
      const ref = this.caseData.internalRef ? this.caseData.internalRef : this.caseData.invoice_number
        axios.postDataWithToken("/auth/save-or-update-case-tasks",{
          internalRef: ref,
          task: newTask
        },this.getAccessToken)
        .then(res => {
          this.$store.commit('setLoader',false)
          if(res && res.status === "success"){
            this.caseData.tasks = res.tasks
            this.$toast.success("Task saved successfully!",{duration:5000})
          }else{
            this.$toast.error(res.message,{duration:5000})
          }
        })
      // Automatically add a Chronology entry that the task was created
      // const logEntry = {
      //   date: new Date().toISOString().substr(0, 10),
      //   author: 'System',
      //   description: 'New Task Created: ' + newTask.title + ' (Assigned to: ' + newTask.assignedTo + ')',
      //   type: 'log'
      // };
      //this.caseData.chronology.unshift(logEntry);
    }
    }
  }
  </script>
  
  <style scoped>
  .task-list-container {
    min-height: 400px;
    padding-bottom: 20px;
  }
  .border-right {
    border-right: 1px solid #e0e0e0;
  }
  </style>